import {take, fork, select, call,put} from "redux-saga/effects";
import {getCurrentStore, getUserInfo} from "../../reducers/app";
import {CODES} from "../../constants";
import API from "../../api/api";
import {toast} from "react-toastify";
import {getScanQrStatus, getTransQrStatus} from "../../reducers/dashboard";
import {globalIntl} from "../App/App";
import {PAY_STATUS} from "../../reducers/types";

function *genTransQr (data: any): Generator<any, void, any> {
    let loading = yield select(getTransQrStatus)
    if(loading) return
    yield put({type: 'TRANS_QR_LOADING', payload: {status: true}})

    let userInfo = yield select(getUserInfo)
    let storeId = yield select(getCurrentStore)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...data,
        storeId: storeId === -1 ? null : storeId
    }
    let resp = yield call(API.createTransQr, params)
    if(resp.code === CODES.SUCCESS && resp.data){
        yield put({type: 'CREATE_TRANS_QR_SUCC', payload: resp.data})
    }
    yield put({type: 'TRANS_QR_LOADING', payload: {status: false}})
}

function *genScanQr(data: any): Generator<any, void, any>{
    let loading = yield select(getScanQrStatus)
    if(loading) return
    yield put({type: 'SCAN_QR_LOADING', payload: {status: true}})
    let userInfo = yield select(getUserInfo)
    let storeId = yield select(getCurrentStore)

    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...data,
        storeId: storeId === -1 ? null : storeId
    }
    let resp = yield call(API.createScanQr, params)
    if(resp.code === CODES.SUCCESS && resp.data){
        if(resp.data.status === PAY_STATUS.PAY_SUCCESS){
            toast.success(globalIntl.formatMessage({id: 'paySucc'}) + '!')
            yield put({type: 'SCAN_QR_SUCCESS', payload: resp.data})
        }else if(resp.data.status === PAY_STATUS.UNPAID){
            toast.warn(globalIntl.formatMessage({id: 'unpaidToast'}), {delay: 8000})
        }else{
            toast.error(globalIntl.formatMessage({id: 'transFailTips'}))
        }
    }else{
        // toast.error(resp.msg)
        yield put({type: 'CLOSE_SCAN_QR_MODAL'})
    }
    yield put({type: 'SCAN_QR_LOADING', payload: {status: false}})
}
export function* getIndexStat(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    let storeId = yield select(getCurrentStore)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        storeId: storeId
    }
    let resp = yield call(API.getInexState, params)
    if (resp.code === CODES.SUCCESS && resp.data) {
        yield put({type: 'SET_INDEX_STAT', payload: resp.data})
    }
}

export function *watchCashier(){
    while (true) {
        let {payload} =  yield take('CREATE_ORDER')
        console.log(payload)
        if(payload.orderType === 'transQr'){
            yield fork(genTransQr, payload.data)
        }else if(payload.orderType === 'scanQr'){
            yield fork(genScanQr, payload.data)
        }
    }
}
